export default __webpack_public_path__ + "static/media/devIcon.59d33643.png";